import { useState } from "react";
import { FiSearch, FiFilter } from "react-icons/fi";
import DashboardLayout from "./DashboardLayout";
import { useDashboard } from "../../context/DashboardContext";
import CanvasWrapper from "../canvas_drag_N_DROP/CanvasWrapper";

const tabs = ["Récents", "Favoris", "Mes projets", "Optimisation"];

const recommended = [
  {
    title: "Démarrer une infrastructure Azure",
    description: "Créer une architecture basique sur Azure",
    image: "/images/azure.png",
  },
  {
    title: "Projet hybride multicloud",
    description: "Configurer un projet Azure + AWS",
    image: "/images/hybrid.png",
  },
  {
    title: "CI/CD avec Azure DevOps",
    description: "Configurer pipeline YAML et Terraform",
    image: "/images/devops.png",
  },
];

const Dashboard = () => {
  const { currentView } = useDashboard();
  const [activeTab, setActiveTab] = useState("Récents");

  return (
    <DashboardLayout>
      {currentView === "canvas" ? (
        <CanvasWrapper />
      ) : (
        <>
          {/* Bouton créer projet et recherche */}
          <div className="flex justify-between items-center mb-6 flex-wrap gap-2">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
              + Créer un projet
            </button>
            <div className="flex items-center space-x-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Filtrer par mot clé"
                  className="pl-10 pr-4 py-2 rounded border border-gray-300 text-black"
                />
                <FiSearch className="absolute top-2.5 left-2.5 w-5 h-5 text-gray-500" />
              </div>
              <button className="px-4 py-2 border rounded flex items-center gap-1 text-black">
                <FiFilter className="text-gray-600" />
                Filtrer
              </button>
            </div>
          </div>

          {/* Recommandé */}
          <h2 className="text-lg font-semibold mb-4 text-black">Recommandé</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            {recommended.map((item, i) => (
              <div
                key={i}
                className="bg-white p-4 shadow rounded hover:shadow-lg transition"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-32 w-full object-contain mb-2"
                />
                <h3 className="font-semibold">{item.title}</h3>
                <p className="text-sm text-gray-500">{item.description}</p>
                <button className="mt-2 text-blue-600 hover:underline">
                  Ouvrir
                </button>
              </div>
            ))}
          </div>

          {/* Onglets filtrants */}
          <div className="flex flex-wrap gap-2 mb-6">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`px-4 py-1 rounded-full border ${
                  tab === activeTab
                    ? "bg-black text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Placeholder */}
          <div className="text-center text-gray-500 p-8 bg-white rounded shadow">
            <img
              src="/images/empty-folder.png"
              alt="Empty"
              className="mx-auto mb-4 w-24"
            />
            <p className="font-medium">
              Recherchez le contenu récemment ouvert ici
            </p>
            <p className="text-sm mt-1">
              Une fois que vous avez ouvert du contenu, il apparaîtra ici pour un
              accès rapide.
            </p>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default Dashboard;
